export type AppTheme = typeof lightTheme;

const lightTheme = {
  accent: '#EC008B',
  purple: '#606',
  grey: {
    primary: '#95A0A9',
    light: '#EBEDEF',
    light2: '#F7F9FA',
    dark: '#6f777d',
  },
  red: '#ff1845',
  black: '#000',
  white: '#fff',
  fontColor: { primary: '#23364B' },
};

export default lightTheme;
